document.addEventListener("DOMContentLoaded", () => {
  // Elements
  const toggleHeader = document.getElementById("order-summary-toggle-header");
  const toggleBtn = document.getElementById("order-summary-toggle-btn");
  const summaryDetails = document.getElementById("order-summary-details");
  const orderItemsContainer = document.getElementById("order-items");
  const orderTotalEl = document.getElementById("order-total");
  const orderItemCountEl = document.getElementById("order-summary-item-count");
  const orderSubtotalEl = document.getElementById("order-summary-subtotal");
  const clearOrderBtn = document.getElementById("clear-order-btn");
  const submitOrderBtn = document.getElementById("submit-order-btn");
  const headerCount = document.getElementById("order-summary-header-count");
  const headerTotal = document.getElementById("order-summary-header-total");

  // contact fields
  const nameInput = document.getElementById("customer-name");
  const companyInput = document.getElementById("customer-company");
  const emailInput = document.getElementById("customer-email");
  const phoneInput = document.getElementById("customer-phone");

  // address fields
  const addressLine1Input = document.getElementById("customer-address-line1");
  const addressLine2Input = document.getElementById("customer-address-line2");
  const cityInput = document.getElementById("customer-city");
  const postalInput = document.getElementById("customer-postal");

  const orderDetails = JSON.parse(localStorage.getItem("orderDetails")) || {};
  const address = orderDetails.address || {};

  nameInput.value = orderDetails.name || "";
  companyInput.value = orderDetails.companyName || "";
  emailInput.value = orderDetails.email || "";
  phoneInput.value = orderDetails.phone || "";

  addressLine1Input.value = address.line1 || "";
  addressLine2Input.value = address.line2 || "";
  cityInput.value = address.city || "";
  postalInput.value = address.postalCode || "";

  // Attach 'input' event listeners to all fields
  document.querySelectorAll(".order-info-fields input").forEach(input => {
    input.addEventListener("input", saveOrderDetails);
  });

  // --- Utilities ---
  function getOrderItems() {
    const orderData = JSON.parse(localStorage.getItem("orderItems")) || {};
    const flatItems = [];

    Object.values(orderData).forEach(productVariants => {
      Object.values(productVariants).forEach(variant => {
        flatItems.push(variant);
      });
    });

    return flatItems;
  }

  function getOrderDetails() {
    return JSON.parse(localStorage.getItem("orderDetails")) || {};
  }

  function saveOrderItems(orderItems) {
    localStorage.setItem("orderItems", JSON.stringify(orderItems));
  }

  function saveOrderDetails() {
    const updatedDetails = {
      name: nameInput.value,
      companyName: companyInput.value,
      email: emailInput.value,
      phone: phoneInput.value,
      address: {
        line1: addressLine1Input.value,
        line2: addressLine2Input.value,
        city: cityInput.value,
        postalCode: postalInput.value
      }
    };
    localStorage.setItem("orderDetails", JSON.stringify(updatedDetails));
  }

  function calculateTotal(orderItems) {
    return orderItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  }

  // --- Rendering ---
  function renderSummary() {
    const orderItems = getOrderItems();
    const totalItems = orderItems.reduce((sum, item) => sum + item.quantity, 0);
    const subtotal = calculateTotal(orderItems);

    orderItemCountEl.textContent = totalItems;
    orderSubtotalEl.textContent = `$${subtotal.toFixed(2)}`;
    orderTotalEl.textContent = `$${subtotal.toFixed(2)}`;

    headerCount.textContent = `${totalItems} item${totalItems === 1 ? "" : "s"}`;
    headerTotal.textContent = `$${subtotal.toFixed(2)}`;
  }

  function renderDetails() {
    const orderItems = getOrderItems();
    orderItemsContainer.innerHTML = "";

    orderItems.forEach(item => {
      const variantSpan = item.variantTitle ? `<span class="order-item-variant">${item.variantTitle}</span>` : "";
      const row = document.createElement("div");
      row.className = "order-item";
      row.innerHTML = `
        <img src="${item.image}" alt="" />
        <div class="order-item-details">
          <span class="order-item-title">${item.productTitle}</span>
          ${variantSpan}
          <span class="order-item-qty">Qty: ${item.quantity} × $${item.price.toFixed(2)}</span>
        </div>
        <span class="order-item-price">$${(item.price * item.quantity).toFixed(2)}</span>
      `;
      orderItemsContainer.appendChild(row);
    });
  }

  // --- Expand/Collapse Logic ---
  summaryDetails.style.display = "none";
  toggleBtn.setAttribute("aria-expanded", "false");

  function toggleSummaryDetails() {
    const expanded = toggleBtn.getAttribute("aria-expanded") === "true";
    if (expanded) {
      summaryDetails.style.display = "none";
      headerCount.style.display = "block"
      headerTotal.style.display = "block"
      toggleBtn.setAttribute("aria-expanded", "false");
    } else {
      renderDetails();
      summaryDetails.style.display = "flex";
      headerCount.style.display = "none"
      headerTotal.style.display = "none"
      toggleBtn.setAttribute("aria-expanded", "true");
    }
  }

  toggleHeader.addEventListener("click", toggleSummaryDetails);
  toggleBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    toggleSummaryDetails();
  });

  // --- Button Handlers ---
  clearOrderBtn.addEventListener("click", () => {
    if (confirm("Are you sure you want to clear the order?")) {
      saveOrderItems({});
      saveOrderDetails({});
      renderSummary();
      renderDetails();
      summaryDetails.style.display = "none";
      toggleBtn.setAttribute("aria-expanded", "false");
    }
  });

  submitOrderBtn.addEventListener("click", () => {
    downloadOrderPdf();
    createXeroOrder();
  });

  function downloadOrderPdf() {
    const orderItems = getOrderItems();
    if (orderItems.length === 0) {
      alert("No items in order.");
      return;
    }

    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    // --- Header ---
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text("WHOLESALE", 105, 18, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(16);
    doc.text("Order Form", 105, 28, { align: "center" });

    // --- Customer Info ---
    const customerName = document.querySelector('.order-summary-meta')?.textContent.replace("Customer:", "").trim() || "Guest";
    const today = new Date();
    const dateStr = today.toLocaleDateString();

    doc.setFontSize(10);
    doc.text(`DATE: ${dateStr}`, 14, 40);
    doc.text(`ORDER #: __________`, 110, 40);

    doc.text(`NAME: ${customerName}`, 14, 48);
    doc.text(`COMPANY: ____________________`, 110, 48);

    doc.text(`EMAIL: ____________________`, 14, 56);
    doc.text(`PHONE: ____________________`, 110, 56);

    doc.text(`SHIPPING ADDRESS: ____________________`, 14, 64);
    doc.text(`BILLING ADDRESS: ____________________`, 110, 64);

    const tableBody = orderItems.map((item, idx) => [
      item.id ? String(item.id) : (item.sku ? String(item.sku) : (item.sku1 + item.sku2)), // Adjust as needed
      item.title,
      `$${item.price.toFixed(2)}`,
      item.quantity.toString(),
      `$${(item.price * item.quantity).toFixed(2)}`
    ]);

    doc.autoTable({
      head: [['ITEM NO', 'PRODUCT', 'UNIT PRICE', 'QTY', 'TOTAL PRICE']],
      body: tableBody,
      startY: 75,
      theme: 'grid',
      styles: { fontSize: 10, cellPadding: 3 },
      headStyles: { fillColor: [240, 240, 240], textColor: 50, fontStyle: 'bold' },
      columnStyles: {
        0: { cellWidth: 30 }, // ID column
        1: { cellWidth: 100, overflow: 'ellipsize' },
        2: { cellWidth: 20 },
        3: { cellWidth: 15 },
        4: { cellWidth: 20 }
      },
      margin: { left: 14, right: 14 },
      didParseCell: function (data) {
        if (data.column.index === 0 && data.section === 'body') {
          data.cell.styles.fontSize = 8; // Smaller font for ID column
        }
      }
    });

    // --- Payment & Totals ---
    let finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text("PAYMENT METHOD", 14, finalY);
    doc.rect(14, finalY + 2, 50, 18); // payment box
    doc.text("☐ CARD   ☐ PAYPAL   ☐ OTHER", 16, finalY + 12);

    // Totals box
    const subtotal = calculateTotal(orderItems);
    doc.text("SUBTOTAL:", 130, finalY);
    doc.text(`$${subtotal.toFixed(2)}`, 170, finalY, { align: "right" });

    doc.text("TAX:", 130, finalY + 8);
    doc.text("$0.00", 170, finalY + 8, { align: "right" });

    doc.text("SHIPPING:", 130, finalY + 16);
    doc.text("$0.00", 170, finalY + 16, { align: "right" });

    doc.setFont("helvetica", "bold");
    doc.text("TOTAL:", 130, finalY + 24);
    doc.text(`$${subtotal.toFixed(2)}`, 170, finalY + 24, { align: "right" });

    // --- Save PDF ---
    doc.save("wholesale-order.pdf");
  }

  function createOrderPayload() {
    const contactId = summaryDetails.dataset.xeroContactId;
    const shopifyCustomerId = summaryDetails.dataset.shopifyCustomerId;

    // Get customer details from localStorage
    const orderDetails = contactId ? {} : JSON.parse(localStorage.getItem("orderDetails")) || {};
    const address = orderDetails.address || {};

    // Flatten order items from localStorage
    const orderItemsData = JSON.parse(localStorage.getItem("orderItems")) || {};
    const orderItems = [];

    Object.values(orderItemsData).forEach(productVariants => {
      Object.values(productVariants).forEach(variant => {
        orderItems.push({
          description: variant.productTitle + (variant.variantTitle ? ` (${variant.variantTitle})` : ""),
          quantity: variant.quantity,
          unitAmount: variant.price
        });
      });
    });

    // Construct payload
    const payload = {
      contactId: contactId || "",
      shopifyCustomerId: shopifyCustomerId || "",
      name: orderDetails.name || "",
      companyName: orderDetails.companyName || "",
      email: orderDetails.email || "",
      phone: orderDetails.phone || "",
      address: {
        line1: address.line1 || "",
        line2: address.line2 || "",
        city: address.city || "",
        postalCode: address.postalCode || ""
      },
      orderItems: orderItems
    };

    return payload;
  }

  function createXeroOrder() {
    const payload = createOrderPayload();

    fetch("https://xero-wholesale-integration.netlify.app/.netlify/functions/create-invoice", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(res => res.json())
      .then(data => {
        console.log("Invoice created:", data);
        alert("Order sent successfully!");
      })
      .catch(err => {
        console.error("Error creating invoice:", err);
        alert("There was an error sending the order.");
      });
  }

  // --- Init ---
  renderSummary();
});